function debounce(e, t = 300) {
  let s;
  return (...i) => {
    clearTimeout(s), s = setTimeout(() => e.apply(this, i), t)
  }
}
if (!customElements.get("sticky-scroll-direction")) {
  class e extends HTMLElement {
    connectedCallback() {
      this.init()
    }
    init() {
      let e = document.querySelector('store-header[data-is-sticky="true"]');
      this.headerHeight = Number.parseInt(getComputedStyle(this.parentElement).getPropertyValue(
          "--header-height").replace("px", ""), 10), this.container = this.firstElementChild, this
        .currentTop = Number.parseInt(document.documentElement.scrollTop + this
          .getBoundingClientRect().top - this.offsetTop, 10), this.defaultTop = e ? parseInt(this
          .headerHeight + 30, 10) : 48, this.scrollY = window.scrollY, this.minStickySize = this
        .dataset.minStickySize, this.toggleListeners(), window.addEventListener(
          "on:breakpoint-change", this.toggleListeners.bind(this))
    }
    toggleListeners() {
      "lg" === this.minStickySize && theme.mediaMatches.lg || "md" === this.minStickySize && theme
        .mediaMatches.md ? this.addListeners() : this.removeListeners()
    }
    addListeners() {
      this.scrollListener = this.scrollListener || this.handleScroll.bind(this), window
        .addEventListener("scroll", this.scrollListener), this.scrollListener(), this
        .parentElement.dataset.stickyHeightElems && (this.debouncedSetStickyHeights = this
          .debouncedSetStickyHeights || debounce(this.setStickyHeight.bind(this), 500), window
          .addEventListener("resize", this.debouncedSetStickyHeights), "MutationObserver" in
          window && (this.stickyHeightElems = this.parentElement.dataset.stickyHeightElems, this
            .observer = new MutationObserver(this.debouncedSetStickyHeights), document
            .querySelectorAll(this.stickyHeightElems).forEach(e => {
              this.observer.observe(e, {
                childList: !0,
                attributes: !0,
                subtree: !0
              })
            })), this.setStickyHeight()), this.disclosures = this.querySelectorAll("details"),
        this.disclosures && (this.disclosureChangeHandler = this.disclosureChangeHandler || this
          .handleDisclosureChange.bind(this), this.disclosures.forEach(e => {
            e.addEventListener("transitionend", this.disclosureChangeHandler)
          }))
    }
    handleDisclosureChange(e) {
      if (e.target.classList.contains("disclosure__panel")) {
        let t = e.target.closest(".disclosure").querySelector("summary");
        theme.elementUtil.isInViewport(t) || window.scrollTo({
          behavior: "smooth",
          top: t.getBoundingClientRect().top - document.body.getBoundingClientRect().top -
            this.headerHeight - 20
        })
      }
    }
    removeListeners() {
      this.container.style.top = "", window.removeEventListener("scroll", this.scrollListener),
        this.observer && (this.observer.disconnect(), window.removeEventListener("resize", this
          .debouncedSetStickyHeights)), this.disclosures && this.disclosures.forEach(e => {
          e.removeEventListener("transitionend", this.disclosureChangeHandler)
        })
    }
    setStickyHeight() {
      let e = 0;
      document.querySelectorAll(this.stickyHeightElems).forEach(t => {
        e += t.getBoundingClientRect().height
      }), this.parentElement.style.setProperty("--sticky-height", `${parseInt(e,10)}px`)
    }
    handleScroll() {
      let e = this.container.getBoundingClientRect(),
        t = e.top + window.scrollY - this.container.offsetTop + this.defaultTop,
        s = this.container.clientHeight - window.innerHeight;
      window.scrollY < this.scrollY ? this.currentTop -= window.scrollY - this.scrollY : this
        .currentTop += this.scrollY - window.scrollY, this.currentTop = Math.min(Math.max(this
          .currentTop, -s), t, this.defaultTop), this.scrollY = window.scrollY, this.container
        .style.top = `${this.currentTop}px`
    }
  }
  customElements.define("sticky-scroll-direction", e)
}
